import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormMultiSelect from '../form/FormMultiSelect';

import { USER_TYPE_ENUM } from '../constants';

class UserTypeMultiSelect extends PureComponent {
	render() {
		const { value } = this.props;

		let options = [
			{
				value: USER_TYPE_ENUM.drivers,
				display: 'Drivers',
			},
			{
				value: USER_TYPE_ENUM.nonDrivers,
				display: 'Non-drivers',
			},
		];
		options = _.sortBy(options, 'display');

		return <FormMultiSelect {...this.props} value={value} options={options} />;
	}
}

UserTypeMultiSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.array,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	classes: PropTypes.object,
	helpText: PropTypes.string,
};

UserTypeMultiSelect.defaultProps = {
	label: 'User Type',
};

export default UserTypeMultiSelect;
